var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMed003(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.0485 19.0485C15.1485 22.9485 8.84851 22.9485 4.94851 19.0485C1.24851 15.3485 1.04851 9.54843 4.24851 5.64843L5.6485 7.04846C3.2485 10.1485 3.4485 14.7484 6.3485 17.6484C6.5485 17.8484 6.84851 17.9485 7.04851 17.9485C7.24851 17.9485 7.54851 17.8484 7.74851 17.6484C8.14851 17.2484 8.14851 16.6485 7.74851 16.2485C5.64851 14.1485 5.4485 10.8485 7.1485 8.54846L16.2485 17.6484C16.4485 17.8484 16.7485 17.9485 16.9485 17.9485C17.1485 17.9485 17.4485 17.8484 17.6485 17.6484C18.0485 17.2484 18.0485 16.6485 17.6485 16.2485L5.6485 4.24853C9.5485 1.04853 15.3485 1.24848 19.0485 4.94848C22.9485 8.74848 22.9485 15.1485 19.0485 19.0485ZM17.6485 7.74853C18.0485 7.34853 18.0485 6.74851 17.6485 6.34851C15.6485 4.34851 12.8485 3.54853 10.0485 4.24853C9.54851 4.34853 9.1485 4.94848 9.3485 5.44848C9.4485 5.94848 10.0485 6.34843 10.5485 6.14843C12.6485 5.64843 14.7485 6.24853 16.2485 7.74853C16.4485 7.94853 16.7485 8.04846 16.9485 8.04846C17.1485 8.04846 17.4485 7.94853 17.6485 7.74853Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMed003);
export default __webpack_public_path__ + "static/media/med003.7e15f21466f9e22134e38ff17cdf383b.svg";
export { ForwardRef as ReactComponent };